export const PartnerPermission = Object.freeze({
  isPartnerAdmin: 'administer-vendor',
  canManagePartnerDetails: 'manage-vendor-details',
  canManagePartnerPaymentDetails: 'manage-payment',
  canManageAppDetails: 'manage-addon-details',
  canManageAppPricing: 'manage-pricing',
  canManagePromotions: 'manage-promotions',
  canViewSalesReport: 'view-sales-reports',
  canViewUsageReports: 'view-usage-reports'
});
export const PartnerRole = Object.freeze({
  engineering: 'engineering',
  marketing: 'marketing',
  finance: 'finance',
  primary: 'primary',
  support: 'support',
  security: 'security'
});